import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { formatDateTime } from "../../../utils/date";
import { BackToMyPageButton } from "../../molecules/BackToMyPageButton";
import { OrderHistoryItem } from "../../organisms/order/OrderHistoryItem";
import { useOrderHistory } from "./hook";

export const OrderHistory: React.FC = () => {
  const { orderHistories, handleCancelOrder, handleReorder } =
    useOrderHistory();

  return (
    <Container>
      <TitleWrapper>利用履歴</TitleWrapper>
      {orderHistories.length <= 0 ? (
        <EmptyOrderHistory>利用履歴がありません。</EmptyOrderHistory>
      ) : (
        <>
          {orderHistories.map((orderHistory) => (
            <OrderHistoryItem
              key={orderHistory.id}
              storeName={orderHistory.store.name}
              storeAddress={
                orderHistory.store.prefecture +
                orderHistory.store.city +
                orderHistory.store.address
              }
              orderId={orderHistory.id}
              pickupDateText={formatDateTime(orderHistory.pickupDate, true)}
              orderStatus={orderHistory.status}
              menus={orderHistory.menus}
              orderPriceWithTax={orderHistory.totalPriceWithTax}
              orderQuantity={orderHistory.quantity}
              tax={orderHistory.taxAmount}
              memo={orderHistory.memo}
              coupon={orderHistory.coupon}
              isAdvancedPayment={orderHistory.isAdvancedPayment}
              canReorder={!orderHistory.isEarlyBird}
              onCancel={() => handleCancelOrder(orderHistory.id)}
              onReOrder={() => handleReorder(orderHistory.id)}
            />
          ))}
        </>
      )}

      <ButtonWrapper>
        <BackToMyPageButton />
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  max-width: 980px;
  min-width: 375px;
`;

const TitleWrapper = styled.div`
  font-size: 20px;
  font-weight: 600;
  padding: 36px 0 30px 0;
  display: flex;
  line-height: 1;
  justify-content: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 50px 0;
  button {
    height: auto;
    line-height: 1;
    font-family: "Hiragino Sans";
    padding: 20px 0 18px;
  }
`;

const EmptyOrderHistory = styled.div`
  padding: 50px 0 300px 0;
  text-align: center;
`;
